import { createContext, useContext, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { calculateScore } from './scoreEngine';

const EMPTY_SCORE = { earned: 0, max: 0, percent: 0, recommendations: [] };
const LiveScoreContext = createContext(EMPTY_SCORE);

export const LiveScoreProvider = ({ children }) => {
    const { watch } = useFormContext();
    const formValues = watch();

    const score = useMemo(() => calculateScore(formValues), [formValues]);

    return <LiveScoreContext.Provider value={score}>{children}</LiveScoreContext.Provider>;
};

export const useLiveScoreValue = () => useContext(LiveScoreContext);
